export default __webpack_public_path__ + "static/web_img3-aaad8a5a0231d801f0389b03d27c2d0c.webp";